import { render } from "./Container.vue?vue&type=template&id=90a584fe&scoped=true"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"

import "./Container.vue?vue&type=style&index=0&id=90a584fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-90a584fe"

export default script